module.exports = __webpack_public_path__ + "h5assets/img/new-collabs-level-company@2x.2d03fa1.png";